"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WSGenericClassDecorator = (...methods) => (originalConstructor) => {
    const methodList = [...methods];
    const decoratedConstructor = function (...args) {
        const serviceInstance = new originalConstructor(args);
        const servicePrototype = Object.getPrototypeOf(serviceInstance);
        for (const prop of Object.getOwnPropertyNames(servicePrototype)) {
            if (prop === 'constructor' || typeof serviceInstance[prop] !== 'function' || methodList.includes(prop))
                continue;
            const originalFunction = serviceInstance[prop];
            serviceInstance[prop] = (...funcArgs) => __awaiter(this, void 0, void 0, function* () {
                for (const methodName of methodList) {
                    yield serviceInstance[methodName]();
                }
                return originalFunction.apply(serviceInstance, funcArgs);
            });
        }
        return serviceInstance;
    };
    decoratedConstructor.prototype = originalConstructor.prototype;
    return decoratedConstructor;
};
exports.EnsureServiceInit = exports.WSGenericClassDecorator('initService');
//# sourceMappingURL=decorators.js.map